<template>
    <div>
        <div class="row g-4 settings-section">
            <div class="col-12 col-md-4">
                <h3 class="section-title">API Key</h3>
                <div class="section-intro"></div>
            </div>
            <div class="col-12 col-md-8">
                <div class="app-card app-card-settings shadow-sm p-4">

                    <div class="app-card-body">
                        <form class="settings-form">
                            <div class="mb-3">
                                <label for="token" class="form-label">API Bearer Token</label>
                                <input id="token" type="text" class="form-control" v-model="user.token" autocomplete="off" readonly>
                            </div>

                            <button type="button" class="btn app-btn-primary" @click.prevent="generateNewToken">Generate
                                new token</button>

                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "profileComponent",

    data() {
        return {
            user: {
                token: null,
            },
            errors: {}
        }
    },

    created() {

    },

    methods: {

        generateNewToken: function () {
            axios.post(`/profile/generate-apitoken`)
            .then(response => {
                this.$set(this.user, 'token', response.data.token);
                Toast.fire({ icon: 'success', title: response.data.message });
            })
            .catch(error => {
                console.error(error);
                Toast.fire({ icon: 'error', title: 'Failed to generate token' });
            });
        }
    }

}
</script>

<style scoped></style>
